import { render } from "./NearestJobs.vue?vue&type=template&id=33f979fa&scoped=true"
import script from "./NearestJobs.vue?vue&type=script&lang=js"
export * from "./NearestJobs.vue?vue&type=script&lang=js"

import "./NearestJobs.vue?vue&type=style&index=0&id=33f979fa&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f979fa"]])

export default __exports__